// eslint-disable-next-line
export const PLAYER_CARD = {
  ADD_RG_EXCLUSION: 'adm/api/casino-auth/v1/exclusion',
  GET_COUNTRIES_LIST: 'api-public/casino-auth/countries',
  GET_PLAYERS: 'adm/api/casino-auth/v1/players',
  GET_PLAYER_BALANCE: 'api/adm/wallet/v1/player/balance',
  GET_RG_EXCLUSION: 'adm/api/casino-auth/v1/exclusion',
  UPDATE_PLAYER: 'adm/api/casino-auth/v1/players/update',
  UPDATE_ACCOUNT_STATUS: 'adm/api/casino-auth/v1/players/change-account-status',
  UPDATE_KYC_STATUS: 'adm/api/casino-auth/v1/players/change-kyc-status',
  SET_PLAYER_BALANCE: 'external-api/player/setbalance',
}
